<div class="audiresult-container" style="font-size: 0.8rem; background-color: white;" class="px-4">

  <div class="result-intro">
    <h3>Actividad Reciente</h3>
    <p>Registro cronológico de todas las operaciones realizadas en el sistema</p>
  </div>
  <div>

    <p-table #dt [value]="ACTIVITIES" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25,50,100,500]"
      [globalFilterFields]="['description', 'type']" scrollable="true" scrollHeight="600px"
      style="margin-top: 1rem; width: 100%;">

      <ng-template pTemplate="caption">
        <div class="p-d-flex p-ai-center justify-content-between d-flex flex-row p-mb-2" style="gap: 0.5rem;">
          <span class="p-input-icon-left" style="flex-grow: 1;">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
              placeholder="Buscar en descripción..." style="width: 100%;" />
          </span>
          <button pButton type="button" label="Exportar Excel" icon="pi pi-file-excel" class="p-button-success"
            (click)="exportexcel()"></button>
        </div>
      </ng-template>

      <!-- HEADER -->
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 120px; min-width: 120px;" pSortableColumn="type">
            Tipo <p-sortIcon field="type"></p-sortIcon>
          </th>
          <th style="width: 200px; min-width: 200px;" pSortableColumn="subject_type">
            Entidad afectada <p-sortIcon field="subject_type"></p-sortIcon>
          </th>
          <th style="width: 200px; min-width: 200px;" pSortableColumn="created_at">
            Fecha y Hora <p-sortIcon field="created_at"></p-sortIcon>
          </th>
          <th style="min-width: 300px;" pSortableColumn="description">
            Descripción <p-sortIcon field="description"></p-sortIcon>
          </th>
          <th style="width: 240px; min-width: 240px; text-align: center;">
            Detalles
          </th>
        </tr>
      </ng-template>

      <!-- BODY -->
      <ng-template pTemplate="body" let-activity>
        <tr>
          <td style="width: 120px; min-width: 120px;">
            <span [ngSwitch]="activity.type" class="badge-type">
              <span *ngSwitchCase="'create'" class="badge create">
                <i class="pi pi-plus-circle"></i> {{activity.type}}
              </span>
              <span *ngSwitchCase="'read'" class="badge read">
                <i class="pi pi-eye"></i> {{activity.type}}
              </span>
              <span *ngSwitchCase="'update'" class="badge update">
                <i class="pi pi-pencil"></i> {{activity.type}}
              </span>
              <span *ngSwitchCase="'delete'" class="badge delete">
                <i class="pi pi-trash"></i> {{activity.type}}
              </span>
              <span *ngSwitchCase="'login'" class="badge login">
                <i class="pi pi-sign-in"></i> {{activity.type}}
              </span>
              <span *ngSwitchCase="'logout'" class="badge logout">
                <i class="pi pi-sign-out"></i> {{activity.type}}
              </span>
              <span *ngSwitchDefault class="badge other">
                <i class="pi pi-question-circle"></i> Otro
              </span>
            </span>
          </td>

          <td style="width: 200px; min-width: 200px;">
            {{ activity.subject_type ? activity.subject_type.replace("API_postgres\\", "") : "N/A" }}
            <span *ngIf="activity.subject_id">#{{ activity.subject_id }}</span>
          </td>

          <td style="width: 200px; min-width: 200px;">
            {{ activity.created_at | date: "dd/MM/yyyy HH:mm:ss" }}
          </td>

          <td style="min-width: 300px;" [innerHTML]="removeIp(activity.description)"></td>

          <td style="width: 240px; min-width: 240px; text-align: center;">
            <div class="d-flex flex-row gap-2" style="justify-content: center;">
              <ng-container *ngIf="activity.properties && activity.properties != '[]' && activity.subject_type != 'API_postgres\\Reportes'; else noDetails">
                <button pButton type="button" label="Ver detalles" icon="pi pi-eye" class="p-button-sm p-button-primary"
                  (click)="onClickGroup(activity)">
                </button>
              </ng-container>
              <ng-template #noDetails>
                <span class="text-muted">Sin detalles</span>
              </ng-template>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>



    <table id="excel-table" style="display:none">
      <tr>
        <th>#</th>
        <th>Descripción</th>
      </tr>
      <tr *ngFor="let activity_excel of activities_excel; index as i;">
        <td>{{i+1}}</td>
        <td>{{activity_excel.description}}</td>
      </tr>
    </table>

  </div>


</div>